import { Box, Text } from '@te-whatu-ora/anatomic'
import type { DisplayInputProps } from '@healthnz-prm/fhir-engine-renderer/types'

const ALLOWED_IMAGE_URL_PATH = 'static.info.content.health.nz/Publicforms/FHIR'

function isAllowedImageUrl(url: string): boolean {
  return (
    url.startsWith(`https://${ALLOWED_IMAGE_URL_PATH}`) ||
    url.startsWith(`http://${ALLOWED_IMAGE_URL_PATH}`)
  )
}

export default function DisplayInput({
  category,
  label,
  labelComponent,
  media
}: DisplayInputProps) {
  if (category === 'security') {
    return (
      <Box backgroundColor='caution5' borderRadius='inputs' padding='small'>
        <Text as='div'>{labelComponent ?? label}</Text>
      </Box>
    )
  }

  if (category === 'help') {
    return (
      <Box backgroundColor='info5' borderRadius='inputs' padding='small'>
        <Text as='div' color='primary100'>
          {labelComponent ?? label}
        </Text>
      </Box>
    )
  }

  return (
    <div>
      {media &&
        media.contentType.startsWith('image/') &&
        isAllowedImageUrl(media.url) && (
          <img
            src={media.url}
            alt={media.title ?? ''}
            style={{ maxWidth: '100%', height: 'auto' }}
          />
        )}
      {(labelComponent || label) && (
        <Text as='div'>{labelComponent ?? label}</Text>
      )}
    </div>
  )
}
